import { OnInit, Input, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'eco-error',
    templateUrl: 'error.component.html',
    styleUrls: ['error.component.scss']
})

export class ErrorComponent implements OnInit {

    existeMail = false;
    sMensaje: string;

    constructor(private route: ActivatedRoute) { }

    ngOnInit(): void {

        // Cargamos el mensaje de entrada
        this.route.params.subscribe(params => { this.sMensaje = params['desc'].toString(); });
    }
}